export var TLoaderButtonState;
(function (TLoaderButtonState) {
    TLoaderButtonState["Normal"] = "normal";
    TLoaderButtonState["Loading"] = "loading";
    TLoaderButtonState["Disabled"] = "disabled";
})(TLoaderButtonState || (TLoaderButtonState = {}));
//# sourceMappingURL=LoaderButtonTypes.js.map